// extracted by mini-css-extract-plugin
export var auto = "_3i-1";
export var spinner = "_3i-0";